import { NativeAdapter } from '@shapeshiftoss/hdwallet-native'
import { KeyStoreIcon } from 'components/Icons/KeyStoreIcon'

export const DemoConfig = {
  adapter: NativeAdapter,
  icon: KeyStoreIcon,
  name: 'KeyDemo',
}
